import { MisconfigurationsAppView } from '../view/MisconfigurationsAppView';
import { templateMisconfigurationsApp } from '../view/template';
import { MisconfigurationsAppRepository } from '../repository/MisconfigurationsAppRepository';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { MisconfigurationsAppWebComponent } from '..';
import { ColumnKeys, MisconfigurationsAppWebComponentSchema } from '../types';
import {
  getSideNavigationPanelSmartViewsListener,
  getSmartViewsListeners,
} from '../../../grid/genericGridSmartViews/utils';
import { GridEvents } from '../../../grid/types/common';
import { MisconfigurationsSideMenuWebComponent } from '../../sideMenus/misconfigurationsSideMenu';
import {
  applyDetailsToShowExtraData,
  applyDeviceDetailsChangedEventOnSideComponent,
  applyDeviceExtraDetailsChangedEventOnSideComponent,
  createActionDialog,
  createFratDialog,
  getEndpointIdsFromAffectedDevices,
  renderDialogText,
  RiskManagementSideMenuEvents,
} from '../../sideMenus/common/common';
import {
  handleChangeStateBulkSelectionChanged,
  handleChangeWatchlistBulkSelectionChanged,
  handleComplexEnumFilter,
  handlePivotFromExtraDetailsPanelToAdvancedSearch,
  handlePivotFromExtraDetailsPanelToIncidents,
  handleRowsLoadingFinishedEvent,
  handleScan,
  handleSelectionChange,
  overlayOpenListener,
  processAffectedDeviceData,
  buildCategoriesSideMenu,
  updateWatchlist,
  hideResourcesOnMisconfigurationType,
} from '../../common/utils';
import {
  Actions,
  ActionsEvents,
  DetailsType,
  FixStateBulkValues,
  MisconfigurationType,
  InlineMenuExtraDetailsSelectEvents,
  MitigationType,
  SelectionEvents,
} from '../../common/constants';
import { WEB_COMPONENT_MISCONFIGURATIONS_SIDE_MENU } from '../../../webcomponents.constants';
import { translateFn } from '../../../utils/translator.helper';
import { ColumnKeys as DevicesGridColumnKeys } from '../../devicesApp/types';
import { ButtonEvents, GzButtonState } from '../../../ui/gzButton/types';
import { SelectEvents } from '../../../ui/gzSelect/types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import {
  DeviceDetailsChangedEvent,
  DeviceExtraDetailsChangedEvent,
  ShowExtraDataEventDetails,
} from '../../sideMenus/components/deviceDetails/types/types';
import { GzDialog } from '../../../ui/gzDialog/component/GzDialog';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { ContextMenuOverlayEvents } from '../../../ui/gzContextMenuOverlay/component/gzContextMenuOverlay';
import { SideMenuEvents } from '../../../ui/gzSideMenu/types';
import { removeActiveStateFromGzIconFromAffectedDevices } from '../../common/customRenderers';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { showToast } from '../../../tagsManager/helpers/commonFunctions';
import { ToastActionButtonMode, ToastSeverity } from '../../../ui/gzToastNotification/type';
import { isEmpty } from 'lodash';
import { EventTypes, SelectedListItem } from '../../../ui/gzSelectedListItemGenerator/types';
import { GzToastNotificationWebComponent } from '../../../ui/gzToastNotification';
import { navigateToTasksSection } from '../../../utils/navigation.utils';
import { GzSelectedListItemGeneratorWebComponent } from '../../../ui/gzSelectedListItemGenerator';
import { NavigationHelper } from '@nirvana/shared/navigation';

export class MisconfigurationsAppController extends BaseWebComponentController {
  public component: MisconfigurationsAppWebComponent;
  public dataRepository: MisconfigurationsAppRepository;
  public view: MisconfigurationsAppView;
  public viewConstructor: typeof MisconfigurationsAppView;
  public dataRepositoryConstructor: typeof MisconfigurationsAppRepository;

  public confirmButton;

  private selectedItems: Array<any> = [];

  constructor(component: MisconfigurationsAppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MisconfigurationsAppView,
      viewTemplate: templateMisconfigurationsApp,
      dataRepositoryConstructor: MisconfigurationsAppRepository,
    });
  }

  public computeEventListeners() {
    return [
      ...getSmartViewsListeners(
        this.view.dom.$grid,
        this.view.dom.$gridSmartViews,
        this.view.buildGrid.bind(this.view),
        this.view.getTranslations()
      ),
      ...getSideNavigationPanelSmartViewsListener(this.view.dom.$pushBodyLayout, this.view.dom.$gridSmartViews),
      {
        element: this.view.dom.$grid,
        event: GridEvents.ROW_CLICKED,
        callback: this.handleRowClicked,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.ROWS_LOADING_FINISHED,
        callback: handleRowsLoadingFinishedEvent.bind(this),
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_DEVICES_BY_MISCONFIGURATION,
        callback: this.handleViewDevicesByMisconfigurationEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.IGNORE_MISCONFIGURATIONS,
        callback: this.handleIgnoreMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.IGNORE_MISCONFIGURATIONS,
        callback: this.handleIgnoreMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.RESTORE_MISCONFIGURATIONS,
        callback: this.handleRestoreMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.RESTORE_MISCONFIGURATIONS,
        callback: this.handleRestoreMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.FIX_MISCONFIGURATIONS,
        callback: this.handleFixMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.FIX_MISCONFIGURATIONS,
        callback: this.handleFixMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.ROLLBACK_MISCONFIGURATIONS,
        callback: this.handleRollbackMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.ROLLBACK_MISCONFIGURATIONS_INLINE,
        callback: this.handleRollbackMisconfigurationsInlineEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: ActionsEvents.WATCHLIST_CHANGED,
        callback: this.handleWatchlistChangedEvent,
      },
      {
        element: this.view.dom.$grid,
        event: ActionsEvents.WATCHLIST_CHANGED,
        callback: this.handleWatchlistChangedEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.DEVICE_DETAILS_CHANGED,
        callback: this.handleDeviceDetailsChangedEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.DEVICE_DETAILS_SHOW_EXTRA_DATA,
        callback: this.handleDeviceDetailsShowExtraDataEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.DEVICE_EXTRA_DETAILS_CHANGED,
        callback: this.handleDeviceExtraDetailsChangedEvent,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.EXPORT_CSV,
        callback: this.handleCSVExportEvent,
      },
      {
        element: this.view.dom.$scanEmptyStateButton,
        event: ButtonEvents.CLICK,
        callback: handleScan.bind(this),
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.SELECT_ROWS,
        callback: this.handleSelectionChange,
      },
      {
        element: this.view.dom.fixBulk.$select,
        event: SelectEvents.SELECTION_CHANGED,
        callback: (event: CustomEvent) => {
          this.handleFixStateBulkSelectionChanged.call(this, event, 'indicatorId');
        },
      },
      {
        element: this.view.dom.changeStateBulk.$select,
        event: SelectEvents.SELECTION_CHANGED,
        callback: (event: CustomEvent) => {
          handleChangeStateBulkSelectionChanged.call(this, event, 'indicatorId');
        },
      },
      {
        element: this.view.dom.changeWatchlistBulk.$select,
        event: SelectEvents.SELECTION_CHANGED,
        callback: handleChangeWatchlistBulkSelectionChanged.bind(this),
      },
      {
        element: this.view.dom.scanButton.$button,
        event: ButtonEvents.CLICK,
        callback: handleScan.bind(this),
      },
      {
        element: this.view.dom.$sideMenu,
        event: InlineMenuExtraDetailsSelectEvents.viewIncidents,
        callback: handlePivotFromExtraDetailsPanelToIncidents.bind(this),
      },
      {
        element: this.view.dom.$sideMenu,
        event: InlineMenuExtraDetailsSelectEvents.viewEvents,
        callback: handlePivotFromExtraDetailsPanelToAdvancedSearch.bind(this),
      },
      {
        // This was needed in order to modify the pointer-events attribute on body
        // It was being set on none at overlay opening and was preventing
        // automated tests to click on other elements while the overlay was open
        element: this.view.dom.$overlay,
        event: ContextMenuOverlayEvents.OPEN,
        callback: overlayOpenListener,
      },
      {
        element: this.view.dom.$grid,
        event: SelectionEvents.RESOURCE_ICON_CLICK,
        callback: this.handleAffectedResourceIconClickedEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: SideMenuEvents.CLOSE,
        callback: this.handleRightSideNavClosed,
      },
    ];
  }

  async getDataForView(): Promise<MisconfigurationsAppWebComponentSchema> {
    return {
      data: await this.dataRepository.getDataForView(),
      externalFilters: this.component.externalFilters,
    };
  }

  async handleRowClicked(event: CustomEvent) {
    if (!event.detail.rowDetails) {
      // header was clicked, so we do nothing
      return;
    }

    const item = event.detail.rowDetails;

    const component = new MisconfigurationsSideMenuWebComponent();
    component.item = item;
    this.view.dom.$sideMenu.setMenuContent(component);
    this.view.dom.$sideMenu.openSideMenu();

    // For cloud risks we do not have Resources section
    if (hideResourcesOnMisconfigurationType(item.subcategory)) {
      component.deviceDetailsEmptyState = true;
    } else {
      const { firstEndpointIdFromAffectedDevice, allEndpointsIds } = getEndpointIdsFromAffectedDevices(
        item.affectedDevices
      );

      try {
        component.item.countDevicesToRollback = await ConsoleRequest.createRequest<any>({
          dataProviderType: DataProviderType.CORE,
          endpoint: 'CompanyEndpointRollbackState',
          method: 'countDevicesToRollbackByIndicatorId',
          payload: {
            companyId: event.detail.rowDetails.company._id,
            indicatorId: event.detail.rowDetails.indicatorId,
          },
        });
      } catch (e) {
        component.item.countDevicesToRollback = 0;
      }

      if (!firstEndpointIdFromAffectedDevice) {
        component.deviceDetailsEmptyState = true;
        return;
      }

      try {
        const deviceDetailsDataResponse = await ConsoleRequest.createRequest<any>({
          dataProviderType: DataProviderType.CORE,
          endpoint: 'RiskManagementDevices',
          method: 'getExtraDetailsForDevice',
          payload: {
            companyId: item.company._id,
            endpointId: firstEndpointIdFromAffectedDevice,
            type: DetailsType.MISCONFIGURATION,
            uniqueIdentifierForFinding: item.indicatorId,
          },
        });

        if (deviceDetailsDataResponse && Object.keys(deviceDetailsDataResponse).length > 0) {
          component.deviceInitialDropdownDetails = {
            endpointId: deviceDetailsDataResponse['device']['id'],
            endpointName: deviceDetailsDataResponse['device']['name'],
            companyId: item.company._id,
            endpointIds: allEndpointsIds,
            uniqueIdentifierForFinding: item.indicatorId,
          };

          component.initialDeviceDetails = deviceDetailsDataResponse['specifics'];
          component.deviceDetails = deviceDetailsDataResponse['specifics'];
        }
      } catch (e) {
        component.deviceDetailsHasErrors = true;
      }
    }
  }

  private handleViewDevicesByMisconfigurationEvent(event: CustomEvent) {
    const { indicatorId, companyId } = event.detail;
    const params = {
      filters: [
        {
          [DevicesGridColumnKeys.DEVICE_MISCONFIGURATIONS]: { complexEnumFilter: [{ value: indicatorId }] },
        },
        {
          [DevicesGridColumnKeys.COMPANY]: { exactMatch: companyId },
        },
      ],
    };

    NavigationHelper.navigateTo('/risk-management-resources', params);
  }

  private handleIgnoreMisconfigurationsEvent(event: CustomEvent) {
    const { indicatorsIds, companyId } = event.detail;

    this.createIgnoreDialog(indicatorsIds, companyId);
  }

  private handleRestoreMisconfigurationsEvent(event: CustomEvent) {
    const { indicatorsIds, companyId } = event.detail;

    this.createRestoreDialog(indicatorsIds, companyId);
  }

  private handleFixMisconfigurationsEvent(event: CustomEvent) {
    const { indicatorsIds, companyId, hasFrat } = event.detail;

    this.createFixRiskDialog(indicatorsIds, companyId, hasFrat);
  }

  private async handleAffectedResourceIconClickedEvent(event: CustomEvent) {
    const { iconType, companyId, affectedResourcesIds } = event.detail;

    const affectedResourcesSideMenu = buildCategoriesSideMenu(companyId, iconType);

    this.view.dom.$sideMenu.setMenuContent(affectedResourcesSideMenu);
    this.view.dom.$sideMenu.openSideMenu();

    let typeToItemsMapping = [];
    try {
      typeToItemsMapping = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'Misconfigurations',
        method: 'getAffectedResourcesDetails',
        payload: {
          companyId,
          affectedResourcesIds,
        },
      });
    } catch (error) {
      affectedResourcesSideMenu.hasErrors = true;
    }

    const categoriesForSidePanel = processAffectedDeviceData(typeToItemsMapping);
    affectedResourcesSideMenu.initialCategories = categoriesForSidePanel;
  }

  handleRightSideNavClosed() {
    removeActiveStateFromGzIconFromAffectedDevices(this.view);
  }

  private handleRollbackMisconfigurationsEvent(event: CustomEvent) {
    const { indicatorsIds, companyId, hasFrat } = event.detail;
    this.createRollbackRiskDialog(indicatorsIds, companyId, hasFrat);
  }

  private async handleRollbackMisconfigurationsInlineEvent(event: CustomEvent) {
    let countDevicesToRollback = 0;

    try {
      countDevicesToRollback = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'CompanyEndpointRollbackState',
        method: 'countDevicesToRollbackByIndicatorId',
        payload: {
          companyId: event.detail.companyId,
          indicatorId: event.detail.indicatorsIds[0],
        },
      });
    } catch (e) {
      countDevicesToRollback = 0;
    }

    if (countDevicesToRollback > 0) {
      this.handleRollbackMisconfigurationsEvent(event);
    } else {
      showToast(ToastSeverity.ERROR, translateFn('Rolling back is not applicable to any endpoints.'));
    }
  }

  private async handleWatchlistChangedEvent(event: CustomEvent) {
    const { newWatchlist, ids, companyId } = event.detail;
    await this.updateWatchlistStatus(newWatchlist, ids, companyId);
  }

  private handleCSVExportEvent(event: CustomEvent) {
    this.view.dom.$grid.controller?.updateCsvButtonState(
      GzButtonState.IS_LOADING,
      this.dependencies.translateFn('Change the current filter selection to generate a new export.')
    );

    let filters: any[] = convertGridFiltersToExtJsFilters(event.detail.filters);
    const complexEnumFilterColumns = [
      ColumnKeys.REGIONS,
      ColumnKeys.AFFECTED_DEVICES,
      ColumnKeys.MISCONFIGURATION_NAME,
    ];
    filters = handleComplexEnumFilter(complexEnumFilterColumns, filters);

    const url = app.buildDownloadUrl('Misconfigurations', 'exportItemsAsCsv', null, 'CSV');
    return Application.lib.DownloadManager.download(url, { filters: filters }, true);
  }

  private handleSelectionChange(event: CustomEvent) {
    handleSelectionChange.call(this, event);
    this.calculateFixBulkButtonAvailability(this.view.dom.fixBulk);
  }

  private calculateFixBulkButtonAvailability(fixBulk: {
    $select: { disabled: boolean; options: any };
    $tooltip: { tooltipText: string };
  }) {
    if (this.selectedItems.length > 0 && !this.selectedItems[0]['company']['specifics']['features']['iorUsable']) {
      fixBulk.$select.disabled = true;
      fixBulk.$tooltip.tooltipText = translateFn('Your current license does not provide access to this feature.');
      return;
    }

    fixBulk.$tooltip.tooltipText = '';
    fixBulk.$select.disabled = this.getAutomaticMitigationIndicators().length === 0;
  }

  private handleFixBulkButtonClick() {
    if (this.selectedItems.length === 0) {
      return;
    }

    const { companyId, hasFrat } = this.selectedItems[0];
    const indicatorsIds = this.getFixableIndicators();

    if (indicatorsIds.length === 0) {
      showToast(ToastSeverity.ERROR, translateFn('No targets available for the selected risks'));
    } else {
      this.createFixRiskDialog(indicatorsIds, companyId, hasFrat);
    }
  }

  private handleRollbackBulkButtonClick(event: CustomEvent) {
    if (this.selectedItems.length === 0) {
      return;
    }

    const { companyId, hasFrat } = this.selectedItems[0];
    const indicatorsIds = this.getAutomaticMitigationIndicators();

    this.createRollbackRiskDialog(indicatorsIds, companyId, hasFrat);
  }

  private createFixRiskDialog(indicatorsIds: Array<number>, companyId: string, hasFrat: boolean | undefined) {
    if (hasFrat) {
      createFratDialog();
      return;
    }

    let data: { indicatorsText: string; dialogTitle: string; confirmButtonText: string };

    if (indicatorsIds.length === 1) {
      data = {
        indicatorsText: translateFn(
          'The recommended settings will be applied for fixing the {MISCONFIGURATION_NAME} risk.',
          {
            MISCONFIGURATION_NAME:
              Application.modules.riskManagement.controller.helpers.routinesTranslations.translateRoutineName(
                indicatorsIds[0]
              ),
          }
        ),
        dialogTitle: translateFn('Fix risk?'),
        confirmButtonText: translateFn('Fix risk'),
      };
    } else {
      data = {
        indicatorsText: translateFn(
          'The recommended settings will be applied for fixing {NUMBER_OF_MISCONFIGURATIONS} risks.',
          {
            NUMBER_OF_MISCONFIGURATIONS: indicatorsIds.length,
          }
        ),
        dialogTitle: translateFn('Fix risks?'),
        confirmButtonText: translateFn('Fix risks'),
      };
    }

    const dialogBodyMessage = `
      ${renderDialogText(data.indicatorsText)}
      ${renderDialogText(
        translateFn('A task will be automatically created to apply the settings to the selected resources.')
      )}
    `;

    const requestPayload = {
      parameters: {
        actionType: Actions.FIX_MISCONFIGURATIONS,
        indicatorsIds,
        companyId,
      },
    };
    createActionDialog(
      {
        dialogTitle: data.dialogTitle,
        confirmButtonText: data.confirmButtonText,
        dialogBodyMessage,
      },
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      {
        success: translateFn('The tasks have been successfully created.'),
        error: translateFn('Failed to create tasks.'),
      },
      true
    );
  }

  private async createRollbackRiskDialog(
    indicatorsIds: Array<number>,
    companyId: string,
    hasFrat: boolean | undefined
  ) {
    if (hasFrat) {
      createFratDialog();
      return;
    }

    if (indicatorsIds.length === 1) {
      const { devicesOptions, devicesOptionsErrorState } = await this.getDevicesOptions(indicatorsIds[0], companyId);
      if (isEmpty(devicesOptions)) {
        showToast(ToastSeverity.ERROR, translateFn('Rolling back is not applicable to any endpoints.'));
        return;
      }

      const dialogBody = document.createElement('div');

      const deviceSelection = new GzSelectedListItemGeneratorWebComponent();
      deviceSelection.filterOptions = devicesOptions;
      deviceSelection.classList.add('mt-1');
      deviceSelection.canSelectAll = true;
      deviceSelection.style.cssText = '--body-size-large: var(--body-size); margin-left: -8px;';
      deviceSelection.strings = {
        sectionLeftTitle: translateFn('Resources'),
        sectionRightTitle: translateFn('Selected resources'),
        searchPlaceholderString: 'Search',
        noSearchResultsString: 'No results found',
        allLabel: 'All resources',
        emptyStateText: 'No endpoints selected',
      };

      deviceSelection.addEventListener(EventTypes.CHANGE_SELECTED, () => {
        if (this.confirmButton) {
          this.confirmButton.disabled = isEmpty(deviceSelection.getSelectedValues());
        }
      });

      const result = [
        `<gz-text fontSize="${FontSizes.HEADING_6}">${translateFn(
          'Settings will be reverted for the {MISCONFIGURATION_NAME} risk.',
          {
            MISCONFIGURATION_NAME:
              Application.modules.riskManagement.controller.helpers.routinesTranslations.translateRoutineName(
                indicatorsIds[0]
              ),
          }
        )}
         </gz-text>
        <br>
        <gz-text class="text-description" fontSize="${
          FontSizes.HEADING_6
        }">${Application.modules.riskManagement.controller.helpers.routinesTranslations.translateRoutineDescription(
          indicatorsIds[0]
        )}</gz-text>
        <br>
        <gz-text fontSize="${FontSizes.HEADING_6}">${translateFn(
          'A task will be created to revert the settings on the endpoints.'
        )}</gz-text>
        <br>
        <br>
        <gz-text class="subtitle" fontSize="${FontSizes.HEADING_5}" fontWeight="${FontWeights.SEMIBOLD}">${translateFn(
          'Targets'
        )}</gz-text>
        <br>
        <gz-text fontSize="${FontSizes.HEADING_6}">${translateFn(
          'Select the endpoints you would like to roll back to previous settings.'
        )}</gz-text>
        <br>`,
      ];

      dialogBody.className = 'dialogBody mt-3 mb-6 ml-5 mr-6 w-60';
      dialogBody.innerHTML = [...result].join('');
      dialogBody.appendChild(deviceSelection);

      const dialogFooter = document.createElement('div');

      this.confirmButton = new GzButtonWebComponent();
      this.confirmButton.innerText = translateFn('Roll back fix');
      this.confirmButton.setAttribute('color', 'primary');
      this.confirmButton.setAttribute('class', 'mr-2');
      dialogFooter.appendChild(this.confirmButton);

      const cancelButton = new GzButtonWebComponent();
      cancelButton.innerText = translateFn('Cancel');
      cancelButton.setAttribute('type', 'outline');
      cancelButton.setAttribute('color', 'secondary');
      dialogFooter.appendChild(cancelButton);

      const dialogTitle = translateFn(`Roll back fix?`);

      const dialogConfigs: GzDialog = {
        headline: dialogTitle,
        bodyContent: dialogBody,
        footerContent: dialogFooter,
        isOpen: true,
        isWindow: true,
        closableOutsideBox: false,
      };

      const dialog = GzDialogWebComponent.buildDialogElement(
        dialogConfigs,
        document.querySelector('.mainContainer') as HTMLElement
      );

      const toastMessages = {
        success: translateFn('The tasks have been successfully created.'),
        error: translateFn('Failed to create tasks.'),
      };

      this.confirmButton.addEventListener('click', async () => {
        if (this.confirmButton.showSpinner) {
          return;
        }

        try {
          this.confirmButton.showSpinner = true;

          const requestPayload = {
            parameters: {
              actionType: Actions.ROLLBACK_FIXES,
              indicatorsIds: indicatorsIds,
              companyId: companyId,
              endpointsIds: deviceSelection.getSelectedValues(),
            },
          };

          await ConsoleRequest.createRequest<any>({
            dataProviderType: DataProviderType.ENDPOINTS,
            endpoint: 'RiskManagementActions',
            method: 'performAction',
            payload: requestPayload,
          });

          GzToastNotificationWebComponent.buildToastWrapperElement({
            message: toastMessages.success,
            severity: ToastSeverity.SUCCESS,
            actionButtonText: translateFn('View status.'),
            hasAction: true,
            actionButtonMode: ToastActionButtonMode.LINK,
            actionCallback: () => {
              navigateToTasksSection();
              GzToastNotificationWebComponent.closeAllToasts();
            },
          });
        } catch (error) {
          GzToastNotificationWebComponent.closeAllToasts();
          if (error.err?.exceptionType === 'Exceptions\\NoTargetsFoundException') {
            toastMessages.error = translateFn('Failed to create task. No valid targets found.');
          }
          showToast(ToastSeverity.ERROR, toastMessages.error);
        } finally {
          dialog.close();
          this.view.dom.$sideMenu.closeSideMenu();
          this.view.dom.$grid.controller.resetSelection();
        }
      });

      cancelButton.addEventListener('click', () => {
        dialog.close();
      });
    } else {
      let indicatorsCount = 0;
      try {
        indicatorsCount = await ConsoleRequest.createRequest<any>({
          dataProviderType: DataProviderType.CORE,
          endpoint: 'CompanyEndpointRollbackState',
          method: 'countIndicatorsToRollback',
          payload: {
            companyId: companyId,
            indicatorsIds: indicatorsIds,
          },
        });
      } catch (e) {
        indicatorsCount = 0;
      }

      if (indicatorsCount === 0) {
        showToast(ToastSeverity.ERROR, translateFn('Rolling back is not applicable to any endpoints.'));
      } else {
        let data: { indicatorsText: string; dialogTitle: string; confirmButtonText: string };

        data = {
          indicatorsText:
            indicatorsCount === 1
              ? translateFn('Settings will be reverted for the finding you have selected.', {
                  NUMBER_OF_MISCONFIGURATIONS: indicatorsCount,
                })
              : translateFn(
                  'Settings will be reverted on all impacted endpoints for {NUMBER_OF_MISCONFIGURATIONS} findings you have selected.',
                  {
                    NUMBER_OF_MISCONFIGURATIONS: indicatorsCount,
                  }
                ),
          dialogTitle: translateFn('Roll back fixes?'),
          confirmButtonText: translateFn('Roll back fixes'),
        };

        const dialogBodyMessage = `
          ${renderDialogText(data.indicatorsText)}
          ${renderDialogText(translateFn('A task will be created to revert the settings on the target endpoints.'))}
        `;

        const requestPayload = {
          parameters: {
            actionType: Actions.ROLLBACK_FIXES,
            companyId,
            indicatorsIds,
          },
        };
        createActionDialog(
          {
            dialogTitle: data.dialogTitle,
            confirmButtonText: data.confirmButtonText,
            dialogBodyMessage,
          },
          {
            grid: this.view.dom.$grid,
            sideMenu: this.view.dom.$sideMenu,
          },
          requestPayload,
          {
            success: translateFn('Roll back tasks created successfully.'),
            error: translateFn('Failed to create rollback tasks.'),
          },
          true
        );
      }
    }
  }

  private async getDevicesOptions(indicatorId, companyId) {
    let devicesOptions: SelectedListItem[] = [];
    let devicesOptionsErrorState = true;

    try {
      devicesOptions = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'CompanyEndpointRollbackState',
        method: 'getDevicesToRollbackByIndicatorId',
        payload: {
          companyId: companyId,
          indicatorId: indicatorId,
        },
      });
      devicesOptionsErrorState = false;
    } catch (e) {
      devicesOptionsErrorState = true;
    }

    return { devicesOptions, devicesOptionsErrorState };
  }

  private createIgnoreDialog(indicatorsIds: Array<number>, companyId: string) {
    let data: { dialogTitle: string; confirmButtonText: string; dialogBodyMessage: string; toastMessages: any };

    if (indicatorsIds.length === 1) {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected risk, while still detected, will not be included in the overall resources and company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Ignore risk?'),
        confirmButtonText: translateFn('Ignore risk'),
        toastMessages: {
          success: translateFn('The risk has been ignored. Changes will apply shortly.'),
          error: translateFn('Failed to ignore risk.'),
        },
      };
    } else {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected risks, while still detected, will not be included in the overall resources and company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Ignore risks?'),
        confirmButtonText: translateFn('Ignore risks'),
        toastMessages: {
          success: translateFn('The risks have been ignored. Changes will apply shortly.'),
          error: translateFn('Failed to ignore risks.'),
        },
      };
    }

    const requestPayload = {
      parameters: {
        actionType: Actions.IGNORE_MISCONFIGURATIONS,
        indicatorsIds,
        companyId,
      },
    };
    createActionDialog(
      {
        dialogTitle: data.dialogTitle,
        confirmButtonText: data.confirmButtonText,
        dialogBodyMessage: data.dialogBodyMessage,
      },
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      data.toastMessages
    );
  }

  private createRestoreDialog(indicatorsIds: Array<number>, companyId: string) {
    let data: { dialogTitle: string; confirmButtonText: string; dialogBodyMessage: string; toastMessages: any };

    if (indicatorsIds.length === 1) {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected risk will now be included in the overall company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Restore ignored risk?'),
        confirmButtonText: translateFn('Restore ignored risk'),
        toastMessages: {
          success: translateFn('The risk has been restored. Changes will apply shortly.'),
          error: translateFn('Failed to restore risk.'),
        },
      };
    } else {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected risks will be included in the overall resources and company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Restore ignored risks?'),
        confirmButtonText: translateFn('Restore ignored risks'),
        toastMessages: {
          success: translateFn('The risks have been restored. Changes will apply shortly.'),
          error: translateFn('Failed to restore risks.'),
        },
      };
    }

    const requestPayload = {
      parameters: {
        actionType: Actions.RESTORE_MISCONFIGURATIONS,
        indicatorsIds,
        companyId,
      },
    };
    createActionDialog(
      {
        dialogTitle: data.dialogTitle,
        confirmButtonText: data.confirmButtonText,
        dialogBodyMessage: data.dialogBodyMessage,
      },
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      data.toastMessages
    );
  }

  private async updateWatchlistStatus(newWatchlistStatus: number, indicatorsIds: Array<number>, companyId: string) {
    await updateWatchlist(
      {
        ids: indicatorsIds,
        companyId,
        newWatchlist: newWatchlistStatus,
      },
      this.view.dom.$grid,
      this.view.dom.$sideMenu,
      WEB_COMPONENT_MISCONFIGURATIONS_SIDE_MENU,
      'Misconfigurations'
    );
  }

  private getAutomaticMitigationIndicators(): Array<number> {
    return this.selectedItems
      .filter(item => {
        return item.mitigation !== MitigationType.MANUAL;
      })
      .map(item => item.indicatorId);
  }

  private getFixableIndicators(): Array<number> {
    return this.selectedItems
      .filter(item => {
        if (item.mitigation === MitigationType.MANUAL) {
          return false;
        }

        return (
          item.affectedDevices.reduce((acc, group) => {
            return acc + group.ids.length;
          }, 0) > 0
        );
      })
      .map(item => item.indicatorId);
  }

  private async handleDeviceDetailsChangedEvent(event: CustomEvent) {
    const sideMenuComponent = this.view.dom.$sideMenu.querySelector(
      WEB_COMPONENT_MISCONFIGURATIONS_SIDE_MENU
    ) as MisconfigurationsSideMenuWebComponent;

    await applyDeviceDetailsChangedEventOnSideComponent(
      sideMenuComponent,
      DetailsType.MISCONFIGURATION,
      event.detail as DeviceDetailsChangedEvent
    );
  }

  private async handleDeviceExtraDetailsChangedEvent(event: CustomEvent) {
    const sideMenuComponent = this.view.dom.$sideMenu.querySelector(
      WEB_COMPONENT_MISCONFIGURATIONS_SIDE_MENU
    ) as MisconfigurationsSideMenuWebComponent;

    await applyDeviceExtraDetailsChangedEventOnSideComponent(
      sideMenuComponent,
      DetailsType.MISCONFIGURATION,
      event.detail as DeviceExtraDetailsChangedEvent
    );
  }

  private async handleDeviceDetailsShowExtraDataEvent(event: CustomEvent) {
    const sideMenuComponent = this.view.dom.$sideMenu.querySelector(
      WEB_COMPONENT_MISCONFIGURATIONS_SIDE_MENU
    ) as MisconfigurationsSideMenuWebComponent;

    applyDetailsToShowExtraData(sideMenuComponent, event.detail as ShowExtraDataEventDetails);
  }

  private handleFixStateBulkSelectionChanged(event: CustomEvent, fieldToSelect = '_id') {
    const newState = event.detail.selected;

    if (this.selectedItems.length === 0) {
      return;
    }

    switch (newState) {
      case FixStateBulkValues.FIX_RISKS:
        this.handleFixBulkButtonClick();
        break;
      case FixStateBulkValues.ROLLBACK_FIXES:
        this.handleRollbackBulkButtonClick(event);
        break;
      default:
        break;
    }
  }
}
